import * as types from './constants';

import update from 'immutability-helper';

const initialState = {
  isOpen: false,
  postId: 0,
  commentsVisible: false,
  commentPadding: 0,
  overlayAdVisible: false
};

function slideshowReducer(state=initialState, action) {
  switch (action.type) {
    case types.TOGGLE_SLIDESHOW_VISIBLE:
      return update(state, {
        isOpen: {$set: action.isOpen},
        postId: {$set: action.postId},
        commentsVisible: {$set: false},
        overlayAdVisible: {$set: false}
      });
    case types.CHANGE_SLIDE:
      return update(state, {
        postId: {$set: action.postId}
      });
    case types.TOGGLE_COMMENTS_VISIBLE:
      return update(state, {
        commentsVisible: {$set: !state.commentsVisible}
      });
    case types.SET_COMMENTS_VISIBLE:
      return update(state, {
        commentsVisible: {$set: action.commentsVisible}
      });
    case types.SET_COMMENT_PADDING:
      return update(state, {
        commentPadding: {$set: action.commentPadding}
      });
    case types.SET_OVERLAY_AD_VISIBLE:
      return update(state, {
        overlayAdVisible: {$set: action.visible}
      });
    default:
      return state
  }
}

export default slideshowReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/reducers.es6